module.exports = __webpack_public_path__ + "img/special-bg.9eb4d0b0.png";